import {
  CLOSE_ALL_MODALS,
  REMOVE_ALL_MODALS,
  PUSH_MODAL,
  REMOVE_MODAL_BY_ID,
  CLOSE_MODAL_BY_ID,
} from '../constants';

import {
  closeAndClearAllSystemModals,
  closeAndClearSystemModalById,
  addOrUpdateSystemModal,
} from '../../utilities/modal-helpers';

const initialState = {
  modalStack: [],
};

const systemModals = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_ALL_MODALS:
      return {
        ...state,
        modalStack: closeAndClearAllSystemModals(state.modalStack),
      };
    case REMOVE_ALL_MODALS:
      return {
        ...state,
        modalStack: [],
      };
    case PUSH_MODAL:
      return {
        ...state,
        modalStack: addOrUpdateSystemModal(state.modalStack, action.modal),
      };
    case REMOVE_MODAL_BY_ID:
      return {
        ...state,
        modalStack: state.modalStack.filter(
          modal => modal.modalId !== action.modalId
        ),
      };
    case CLOSE_MODAL_BY_ID:
      return {
        ...state,
        modalStack: closeAndClearSystemModalById(
          state.modalStack,
          action.modalId
        ),
      };
    default:
      return {
        ...state,
      };
  }
};

export default systemModals;
